export const API_ENDPOINTS = {
  //ADMIN_ACCESS_INFO
  get_admin_access_info: "/api/Admin/admin/get_admin_access_info",

  check_session:"/api/Apitranxt/admin/check_session",
  check_sessionRetailer:"/api/Apitranxt/check_session",
  // ADMIN LOGIN
  ADMIN_SEND_OTP: "/api/Payment/admin/dashboardLogin",
  ADMIN_VERIFY_OTP: "/api/Payment/admin/dashboardLogin",
  //DASHBOARD
  ADMIN_DASH_DATA: "/api/Apitranxt/get_dashboard_tranx_data_admin",
  SUPERADMIN_DASH_DATA: "/api/Admin/dashboardData",
  DASH_CHART_DATA: "/api/Payment/admin/getAllDashboardChartDataAdmin",
  DASH_PROFILE_INFO: "/api/Profile/GetUserProfileInfo",
  DASH_ACC_BAL: "/api/Payout/getAccountBalance",
  DASH_GET_BAL: "/api/Payment/bbps/srijipay/getBalance",
  GET_ICORE_BAL: "/api/Payment/bbps/icore/getBalance",
  BANKIT_BAL: "/api/DMT/Bankit/Main/v1/getBalance",
  GENERATE_TOKEN: "/api/Account/Login",

  //dash_report
  GetTransactionsall: "/api/Payments/GetTransactionsall",
  idfcBankSettlement: "/api/Intent/idfcBankSettlement",
  idfcBankStatementDownload: "/api/Intent/v1.0/idfcBankStatement",
  //NAVBAR
  PROFILE_INFO: "/api/Profile/GetUserProfileInfo",
  ACCOUNT_LOGIN: "/api/Account/Login",
  GET_ROLE_DATA: "/api/Payment/admin/getRoleData",
  GET_SUBMENU: "/api/Payment/admin/getSubMenu",
  //TARIFF
  ALL_TARIFF: "/api/Apitranxt/get_all_tariff",
  //CREATE_TARIFF
  CREATE_TARIFF: "/api/Apitranxt/create_tariff",
  ALL_SERVICE_ADMIN: "/api/Apitranxt/get_all_services_admin",
  ALL_API_ROUTES: "/api/Apitranxt/get_all_api_routes_admin",
  CREATE_TARIFF_PLAN: "/api/Apitranxt/create_tariff_plan",
  //ALL_TARIFF
  GET_ALL_TARIFF: "/api/Apitranxt/get_all_tariff_plans",
  UPDATE_TARIFF: "/api/Apitranxt/update_tariff_plan",
  //GET_ALL_LOAD_BANK
  GET_LOADBANK: "/api/Apitranxt/get_all_load_bank",
  CREATE_LOAD_BANK: "/api/Apitranxt/create_load_bank",
  GET_ALL_BANK_LIST: "/api/Apitranxt/get_all_bank_list",
  //LEDGER_REPORT
  GET_ACC_LEDGER: "/api/Apitranxt/get_account_ledger_admin",
  //ADD_FUND
  CREATE_LOAD_REQUEST:
    "/api/Apitranxt/get_user_details_create_load_request_admin",
  REVERSE_FUND: "/api/Apitranxt/admin_fund_transfer",
  GET_LEAN_AMOUNT: "/api/Admin/agentLeanAmount",
  //WALLET_BAL
  GET_WALLET_BAL: "/api/Payment/wallet/getWalletBalance",
  //VIEW_LOAD
  GET_LOAD: "/api/Apitranxt/get_view_load_requests_admin",
  LOAD_APPROVE: "/api/Payment/admin/adminLoadRequestApprove",
  LOAD_REJECT: "/api/Apitranxt/reject_load_request_admin",
  UPDATE_LOAD_REQUEST: "/api/Admin/v1.0/updateLoadRequest",
  //CREATE_LOAD_REQUEST
  CREATE_LOAD_REQUEST:
    "/api/Apitranxt/get_user_details_create_load_request_admin",
  GET_LOAD_BANK: "/api/Apitranxt/getloadbank",
  CREATE_LOAD_REQ_ADMIN: "/api/Apitranxt/create_load_request_admin",
  //CREDIT_REQUEST
  ALL_CREDIT_REQUEST: "/api/Payment/credit/getAllCreditRequests",
  CREDIT_REQ_APPROVE: "/api/Payment/credit/creditRequestApprove",
  CREDIT_REQ_REVERSE: "/api/Payment/credit/creditRequestReverseAmount",
  //OD_submit
  IMAGE_UPLOAD: "/api/Payment/imageUpload",
  OD_DOC_SUBMIT: "/Payment/admin/admininODRequestDocSubmit",
  GET_USER_LIST: "/api/Apitranxt/admin/get_all_user_list_admin",
  //od_report
  GET_ALL_OD_REQ_DOCS: "/api/Payment/credit/getAllODRequestsDocs",
  //api_top_up
  GET_ALL_VENDOR_ACC: "/api/Admin/getAllVendorAccountsAdmin",
  ADMIN_VENDOR_TOPUP: "/api/Admin/adminVendorTopup",
  GET_PAYOUT_STATUS: "/api/Admin/getPayoutStatus",
  ADMIN_VENDOR_TOPUP_V1: "/api/Admin/v1.0/adminVendorTopup",
  DISABLE_VENDOR_ACC: "/api/Admin/v1.0/disableVendorAccount",
  GET_ALL_VENDOR_TOPUP: "/api/Admin/getAllVendorTopupAdmin",
  //
  UPLOAD_ACC_STATEMENT: "/api/Admin/v1.0/uploadAccountStatementData",
  GET_LOAD_REQ_BANK: "/api/Admin/v1.0/getLoadRequestBanks",
  //
  GET_ALL_MERCHANT: "/api/Intent/GetAllMerchant",
  PAYOUT_TOPUP_PROCESS: "/api/Intent/payoutTopupProccess",
  GET_PAYOUT_TOPUP_REPORT: "/api/Intent/v1/getPayoutTopupReport",
  DELETE_VENDOR_TOPUP_ACC: "/api/Admin/deleteVendorTopupAccount",
  CMS_REFUND: "/api/Admin/cmsTransactionRefund",
  //RECON DASH
  GET_DASH_RECON_DATA: "/api/Admin/v1.0/getDashboardReconData",
  TXN_REPORT: "/api/Payments/GetTransactionsreportnew",
  GET_DASH_COMM_CHARGES:
    "api/Admin/v1.0/getDashboardReconDataCommissionAndCharges",
  GET_DASH_COMM_CHARGES_SERVICE:
    "api/Admin/v1.0/getDashboardReconDataServiceWise",
  GET_DUPLICATE_LEDGER: "/api/Admin/v1.0/getDuplicateLedgerEntries",
  GET_DASH_RECON_DATA_MASTER: "/api/Admin/v1.0/getDashboardReconDataMaster",

  //USER
  //View_user_list
  GET_ALL_USER_LIST: "/api/Apitranxt/admin/get_all_user_list_admin",
  UPDATE_PSWD: "/api/Apitranxt/updatepwd",
  SET_TARIFF_PLAN: "/api/Payment/admin/setTariffPlanAdmin",
  GET_ALL_TARIFF_PLAN_ADMIN: "/api/Payment/admin/getAllTariffPlansAdmin",
  //user_view
  CREATE_LOAD_REQUEST:
    "/api/Apitranxt/get_user_details_create_load_request_admin",
  GET_USER_VIEW_PROFILE: "/api/Admin/getUserViewProfileDetails",
  PIN_DATA: "/api/Apitranxt/kyc/pindata",
  USER_DETAIL_UPDATE: "/api/Admin/userDetailsUpdate",
  FETCH_KYC_IMAGE_DATA: "/api/Apitranxt/kyc/fetch_kyc_image_data",
  DIST_GET_PROVIDER_LIST: "/api/Apitranxt/distributor/dist_get_provider_list",
  setAepsBankAccountPrimary: "/api/Admin/v1.0/setAepsBankAccountPrimary",
  GET_USER_LEDGER: "/api/User/v1.0/getUserLedger",
  GET_RETAILER_DMT_REPORT: "/api/Apitranxt/get_retailer_dmt_report",
  GET_RETAILER_BBPS_REPORT: "/api/Apitranxt/get_retailer_bbps_report_all",

  GET_RETAILER_AEPS_REPORT: "/api/Apitranxt/get_retailer_aeps_report",
  AEPS_TRANSACTION_CALLBACK: "/api/Apitranxt/aeps_transaction_callback",
  GET_CMS_REPORT: "/api/Admin/getCMSReport",
  VENDOR_PAYMENT_REFUND_ADMIN: "/api/Admin/vendorPaymentRefundAdmin",
  WALLET_TO_WALLET_REPORT: "/api/Payment/admin/walletToWalletReport",
  CREATE_TARIFF_PLAN: "/api/Admin/createTariffPlan",
  FETCH_TARIFF_PLAN: "/api/Admin/fetchTariffPlan",

  //CREATE_USER
  CREATE_USER: "/api/Apitranxt/create_user",

  //USERMAPPING
  USER_MAP: "/api/Apitranxt/user_map",

  //SERVICE_REQ
  GET_ALL_SERVICE_REQ: "/api/User/getAllServiceRequestS",
  GET_ADMIN_ACTIVITY_LOGS: "/api/Admin/getAdminUserActivityLogs",
  //LEIN REPORT
  LIEN_AMOUNT_REPORT: "/api/Admin/lienAmountReport",
  //QUEUE
  GET_ALL_QUEUE: "/api/Settlement/getAllQueuedSettlements",
  PENDING_SETTLEMENT: "/api/Settlement/processPendingSettlements",
  //DMT
  GET_BENE: "/api/Apitranxt/get_beneficiary_by_accno",
  GET_ALL_BENEFICIARY: "/api/DMT/YesBank/Main/getAllBeneficiary",
  CHECK_REMITTER: "/api/DMT/YesBank/Main/checkRemitter",
  CREATE_REMITTER: "/api/DMT/YesBank/Main/createRemitter",
  ADD_BENEFICIARY: "/api/DMT/YesBank/Main/addBeneficiary",
  VERIFY_BENEFICIARY: "/api/DMT/YesBank/Main/verifyBeneficiary",
  BENEFICIARY_SENDOTP: "/api/DMT/YesBank/Main/addBeneficiarySendOTP",

  LOGIN_USER_ATTEMPTS: "/api/Admin/v1.0/getAllUserLoginAttempts",

  //TECH_SUPPORT
  TWO_FACTOR_REPORT: "/api/Payment/reports/twoFactorReport",
  TWO_FACTOR_STATUS_CHANGE: "/api/Payment/aeps/twoFactorStatusChange",

  //VERSION_CHANGE
  APP_VERSION_CHANGE: "/api/Payment/admin/appVersionChange",
  GET_ALL_SERVICES_ADMIN: "/api/Apitranxt/get_all_services_admin",
  REINITIATE_AEPS: "/api/Payment/admin/reinitiateAepsOnboarding",

  //DOK_KYC_
  DOC_KYC: "/api/Payment/admin/adminDocKycInitiate",

  //SUPPORT
  ALL_TICKET_LIST: "/api/Payment/support/getAllTicketListAdmin",

  GET_ALL_SERVICES: "/api/Payment/admin/getAllServices",
  CHANGE_SERVICE_STATUS: "/api/Payment/admin/changeServiceStatusAdmin",

  RECON_REPORT: "/v1/web/fingpay/reconReportV2.php",
  //AEPS_LOGS
  AEPS_RECON_REPORT: "/instapayReconReport.php",

  //BUMPPY_OUTLET
  INSTANTPAY_OUTLET_LIST: "/api/AEPS/v1.0/getInstapayOutletList",
  GET_OUTLET_LIST: "/api/AEPS/v1.0/Instantpay/getOutletList",
  //
  CREDIT_COMM: "/api/Admin/v1.0/creditCommission",
  //STATUS_CHANGE
  STATUS_CHANGE: "/api/Admin/v1.0/changeTransactionStatus",

  THREEWAY_RECON_MATM: "/3wayReconMatm.php",
  TXN_CREDIT: "/api/Payment/MATM/v1.0/updateTransaction",
  DAILY_RECON: "/v1/web/fingpay/dailyrecon2.php",
  GET_MATM_REPORT: "/api/Admin/getMATMReport",

  //
  ALL_BANK: "/fetchAllBanks.php",
  AEPS_RESPONSE_UPDATE: "/api/Payment/v1.0/webhook/aepsResponseUpdate",
  //creditcard_txn
  CREDIT_CARD_TXN: "/api/PG/getAllCreditCardTransactions",
  CREDIT_DETAILS: "/payment_gateway/config/v1/creditCardDetailsUpdate.php",
  GET_ALL_CARD_DETAILS:
    "/payment_gateway/config/v1/getAllCreditCardDetails.php",
  CREDIT_CARD_DETAILS_UPDATE:
    "/payment_gateway/config/v1/creditCardDetailsUpdate.php",

  //Reports
  GET_DMT_REPORT: "/api/Apitranxt/get_dmt_report_admin",
  DMT_REFUND: "/api/Apitranxt/dmttrans_refund",
  DMT_TXN_REFUND: "/api/Admin/dmtTransactionRefund",
  STATUS_UPDATE: "/api/Payment/admin/changeTransactionStatusAdmin",

  //AEPS_REPORT
  CHECKOUT_STATUS: "/v1/statusCheckPayout.php",
  GET_AEPS_REPORT: "/api/Apitranxt/get_aeps_report_admin",
  SETTLEMENT_REFUND: "/api/Apitranxt/aepssettlement_refund",
  //BBPS_REPORT
  BBPS_REPORT: "/api/Apitranxt/get_bbps_report_admin",
  BBPS_REFUND: "/a/api/Apitranxt/bbpstrans_refund",
  BBPS_TXN_REFUND: "/api/Admin/bbpsTransactionRefund",
  //
  AEPS_SETTLEMENT_REFUND: "/api/Admin/aepsSettlementTransactionRefund",
  //PG
  PG_REPORT: "/api/Payment/reports/getAllPGReport",
  PG_CLAIM: "/api/PG/transactionClaim`",
  transaction_Release: "/api/PG/transactionRelease",
  //
  SALES_VISIT_REPORT: "/api/Payment/admin/salesVisitReport",
  PG_SETTLEMENT: "/api/Payment/reports/getPGSettlementReport",
  PG_REFUND: "/api/Payment/pg/pgSettlementRefund",
  //ALL_TXN_DOWNLOAD
  ALL_DASHBOARD_REPORT: "/api/Payment/pg/getAllDashboardReport",
  CREDIT_CARD_BILL_PAY: "/api/Payment/reports/getCreditCardBillPaymentReport",
  TRANSACTION_REFUND: "/api/Payment/admin/transactionRefundAdmin",
  //
  RELEASE_HOLD: "/api/Payment/pg/releaseHoldingAmountCron",
  FUND_HOLD_REPORT: "/api/Payment/pg/getAllFundHoldReport",

  RELEASE_HOLD_ID: "/api/Payment/pg/releaseFundHoldingByIds",
  //
  ALL_SERVICE: "/getAllReportServices.php",
  ALL_SERVICE_REPORT: "/api/Payment/admin/getAllServicesReportAdmin",
  //PG_REPORT
  PG_REPORT: "/pg/bumppyPaymentGatewayReport.php",
  PG_TXN_UPDATE: "/api/Payment/pg/transactionPGUpdatePipe2",

  //
  GET_ALL_LEDGER: "/api/Admin/getAllLedgerReport",
  //
  GET_ALL_VENDOR_REPORT: "/api/Admin/getAllVendorPaymentsAdminReport",
  //qr_report
  GET_ALL_VIRTUAL_TXN: "/api/Payment/admin/getAllVirtualTransactions",
  QR_CLAIM: "/api/Admin/v1.0/qrTransactionClaim",
  //SALES
  SALES_BUSINESS: "/api/Apitranxt/get_sales_person_business",
  CNF_REPORT: "/api/Apitranxt/get_cnf_use_report_master_admin",
  //KYC
  SERVICE_REQ: "/api/User/approveServiceRequest",
  //
  CHARGEBACK_CASE: "/api/Payment/admin/getAllChargeBackCasesAdmin",
  NEW_CHARGEBACK: "/api/Payment/admin/insertNewChargbackCase",
  CREDIT_KYC_REPORT: "/api/Payment/admin/getAllCreditCardKycReport",
  //
  KYC_REVIEW: "/api/Payment/admin/getAllKycReviewReportAdmin",
  //
  USER_KYC: "/api/Apitranxt/get_all_user_kyc_list_admin",
  KYC_DATA_UPLOAD: "/api/AEPS/kycdataupload",
  ONBOARDING_RECON: "/v1/web/fingpay/onboardingCron.php",
  MERCHANT_ONBOARD: "/v1/web/fingpay/merchantonboardv2.php",
  //KYC
  FETCH_KYC_DATA: "/api/Apitranxt/kyc/fetchkycdata",
  SUBMIT_KYC: "/api/Apitranxt/kyc/submitkyc",
  INSERT_KYC_DATA: "/api/Apitranxt/kyc/insert_verified_kyc_data",
  PAN_LITE: "/api/Verify/panlite",
  PAN_VERIFICATION: "/api/Verification/panVerification",
  AADHAR_OTP: "/api/Verify/aadharotpsend",
  AADHAR_OTP_VERIFY: "/api/Verify/aadharotpverify",
  SUBMIT_KYC_DOC: "/api/Apitranxt/kyc/submitkycdoc",
  FETCH: "/api/fetchkycdata.aspx",
  SUBMIT_DOC: "/api/submitkycdoc.aspx",
  GET_PAYNOW_ID: "/api/Apitranxt/user/get_paynnow_agentid",
  DOC_KYC_APPROVE: "/api/Apitranxt/agent_doc_kyc_approve",
  DOC_KYC_REJECT: "/api/Apitranxt/agent_doc_kyc_reject",
  IMAGE_UPLOAD_KYC: "/api/Payment/kyc/imageUpload",
  DOC_KYC_SUBMIT: "/api/Payment/kyc/userKycDocSubmit",
  UPLOAD_IMG: "/api/uploadimages.aspx",
  submitkycfinal: "/api/submitkycfinal.aspx",
  UPLOAD_IMG: "/api/uploadimages.aspx",

  ///extra pages

  ALL_REWARDS: "/api/PG/getAllRewards",
  ADD_REWARDS: "/api/Admin/addRewardsAdmin",
  GET_OUTLET_LIST: "/api/AEPS/v1.0/Instantpay/getOutletList",
  recond_fullrepor: "/v1/web/fingpay/recond_fullreport.php",

  UPLOAD_bank: "/api/AEPS/kycdatauploadBank",
  ASSIGN_SALES_PRSN: "/api/Apitranxt/assign_sales_person",
  GET_ALL_SALES_PRSN: "/api/Apitranxt/get_all_sales_person",
  BILL_FETCH_ONLINE: "/api/BBPS/billFetchOnline",
  GET_BBPS_BILL: "/api/BBPS/getBBPSBill",
  ALL_PG_COMMERCIALS: "/api/Admin/getAllPGCommercials",
  UPDATE_PG_COMERCIALS: "/api/Admin/updatePGCommercials",
  
  FETCH_FUND: "/api/Payout/Fetchfundbalance",
  userDetailsUpdate: "/api/Admin/userDetailsUpdate",
  sendMoney: "/api/DMT/YesBank/Main/sendMoney",
  sendMoney2: "/api/DMT/YesBank/Main/sendMoney2",

  beneficiaryDeactivate: "/api/DMT/YesBank/Main/beneficiaryDeactivate",
  beneficiaryActivate: "/api/DMT/YesBank/Main/beneficiaryActivate",
  fetchCustomer: "/api/DMT/Bankit/Main/fetchCustomer",
  createCustomerOTP: "/api/DMT/Bankit/Main/createCustomerOTP",
  createCustomer: "/api/DMT/Bankit/Main/createCustomer",
  fetchBeneficiaries: "/api/DMT/Bankit/Main/fetchBeneficiaries",

  fundTransferOtpV1: "/api/DMT/Bankit/Main/fundTransferOtpV1",
  fundTransferV1: "/api/DMT/Bankit/Main/fundTransferV1",
  addBeneficiary: "/api/DMT/Bankit/Main/addBeneficiary",
  bankVerify: "/api/DMT/Bankit/Main/bankVerify",

  fetchCustomerV1: "/api/DMT/Bankit/Main/v1/fetchCustomer",
  createCustomerOTPV1: "/api/DMT/Bankit/Main/v1/createCustomerOTP",
  createCustomerV1: "/api/DMT/Bankit/Main/v1/createCustomer",

  fetchBeneficiariesV1: "/api/DMT/Bankit/Main/v1/fetchBeneficiaries",
  V1fundTransferOtpV1: "/api/DMT/Bankit/Main/v1/fundTransferOtpV1",
  V1fundTransferV1: "/api/DMT/Bankit/Main/v1/fundTransferV1",
  addBeneficiaryV2: "/api/DMT/Bankit/Main/v2/addBeneficiary",

  GetUserledger: "/api/Payments/GetUserledger",

  sendOtp: "/api/User/developer/v1.0/sendOtp",
  validateOtp: "/api/User/developer/v1.0/validateOtp",

  GetUserSettlement: "/api/Payments/GetUserSettlement",
  FetchtransferStatusV2: "/api/Payout/FetchtransferStatusV2",
  sdkClientSettlementRecords: "/payin/api/sdkClientSettlementRecords.php",
  updatePayinSettlement: "/api/Intent/updatePayinSettlement",
  calculatePayinSettlement: "/payin/api/calculatePayinSettlement.php",
  initiatePayinSettlement: "/payin/api/initiatePayinSettlement.php",
  GetMerchantLedgerReport: "/api/Intent/GetMerchantLedgerReport",
  sdkClientSettlementAdmin: "/payin/api/sdkClientSettlementAdmin.php",
  payinAmountSettlement: "/api/Intent/payinAmountSettlement",

  create_newuser: "/api/Apitranxt/create_newuser",
  get_retailer_profile_details: "/api/Apitranxt/get_retailer_profile_details",
  uploadDocsEsign: "/api_integration/agent_concern/v1/uploadDocsEsign.php",
  getAllEsignDocList: "/api_integration/agent_concern/v1/getAllEsignDocList.php",

  getAccountStatement: "/api/Payout/getAccountStatement",
  getAccountStatement1: "/api/Admin/getAccountStatement",
  generateUrl: "/api/CMS/Bankit/Main/generateUrl",
  master_dist_profile_details: "/api/Apitranxt/master_dist_profile_details",
  get_receipt_data: "/api/Apitranxt/user/get_receipt_data",
  checkpassword: "/api/Apitranxt/checkpassword",

  unlockUser: "/api/User/v1.0/unlockUser",
  unlockUserValidateOtp: "api/User/v1.0/unlockUserValidateOtp",

  getKycAndTwoFactorStatus: "/api/AEPS/v1.0/getKycAndTwoFactorStatus",
  twoFactorCheck: "/api/Payment/aeps/twoFactorCheck",
  updateAeps2LatLong: "/api/AEPS/v1.0/updateAeps2LatLong",
  getAeps2LatLong: "/api/AEPS/v1.0/getAeps2LatLong",
  forgetPassword: "/api/Payment/admin/forgetPassword",
  update_admin_access: "/api/Payment/admin/update_admin_access",
  checkpassword: "/api/Apitranxt/checkpassword",
  checkpassword: "/api/Apitranxt/checkpassword",
  checkpassword: "/api/Apitranxt/checkpassword",
};
